import { Breadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const BreadcrumbsNav: React.FunctionComponent<any> = () => {
  const location = useLocation();
  const PathName = location?.pathname?.split("/");
  return (
    <div role="presentation" className="dFlex alignItemsCenter">
      <Breadcrumbs aria-label="breadcrumb">
        {PathName?.[1] && (
          <Link color="primary" to={PathName?.[1]} className="textCapitalize">
            {PathName?.[1]}
          </Link>
        )}
        {PathName?.[2] && (
          <Typography color="text.primary" className="fw500 textTruncate MW300">
            {decodeURIComponent(PathName?.[2])}
          </Typography>
        )}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbsNav;
